var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.accordion),function(bit,index){return [(bit.includes('<h3'))?_c('AccordionItem',{key:index,attrs:{"drawing":_vm.drawing,"headline":bit,"text":_vm.accordion[index + 1] || null}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }